import * as React from 'react';
import { SVGProps } from 'react';

const SvgMute = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m15.363 12-2.22-2.22 1.209-1.209 2.22 2.22 2.22-2.22 1.209 1.209-2.22 2.22 2.22 2.22-1.209 1.209-2.22-2.22-2.22 2.22-1.209-1.209 2.22-2.22zM3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83z" />
  </svg>
);

export default SvgMute;
